import { Card, Row, Typography, Flex } from "antd";
import { FooterHandler } from "./Footer";
import { useTranslation } from "react-i18next";

export function Disclaimer() {
    const { Paragraph, Text, Title } = Typography
    const liStyle = {
        marginBottom: "5px"
    }
    const { t } = useTranslation();
    return (
        <>
            <Row style={{ width: "100%", minHeight: '100vh', display: "flex", justifyContent: "center", marginTop: "60px", marginBottom: "50px",  alignItems: "flex-start" }}>
                <Row className="content">
                    <Card className="scroll" bordered={false} style={{ width: "100%",  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", padding: "20px" }}>
                        <Flex justify="center">
                            <Typography.Title>
                                {t('60001')} {/* Disclaimer */}
                            </Typography.Title>
                        </Flex>

                        <Typography.Paragraph>
                            {t('60002')} {/*The laser safety parameter calculation tool provided on this website is designed to assist users in calculating laser safety parameters based on the IEC 60825-1 standard. While we strive to ensure the accuracy and reliability of the calculations, the tool is provided "as is" without any guarantees or warranties of any kind, either express or implied.*/}

                        </Typography.Paragraph>
                        <Typography.Paragraph>
                            {t('60003')} {/*  Accuracy and Limitations: */}
                           
                        </Typography.Paragraph>
                        <ol>
                            <li style={liStyle}>
                                <strong>{t('60004') /*Accuracy*/}</strong> {t('60005') /*This tool is desigend....*/}
                            </li>
                            <li style={liStyle}>
                                <strong>{t('60006') /*No Professional Advice:*/}</strong> {t('60007') /*The calculations and information provided by this tool */}
                            </li>
                            <li style={liStyle}>
                                <strong>{t('60008') /*Limitation of Liability: */}</strong> {t('60009') /* In no event shall Lasermet, its affiliates, */}
                            </li>
                            <li style={liStyle}>
                                <strong>{t('60010') /*User Responsibility:*/}</strong> {t('60011') /*Users are responsible for verifying the results obtained */}
                            </li>
                        </ol>

                        <Typography.Text type='secondary'>
                            {t('60012') /*By using this tool, you acknowledge and agree to the terms of this disclaimer and accept full responsibility for any risks associated with its use. */}
                        </Typography.Text>

                    </Card>
                </Row>
            </Row>
            <FooterHandler />
        </>
    )

}